import { useEffect, useState } from "react";
import AddRankingPoints from "../rankingpoints/components/addRankingPoints";
import AdvanceTable from "../../../components/advanceTable";
import { Button } from "../../../components/ui/button";
import { Icon } from "@iconify/react";
import Common from "../../../helper/common";
import { AppSearchSelect } from "../../../components/appComponents";
import {
  SearchTypeEnum,
  TournamentMatchStageEnum,
} from "../../../constants/appConstant";

const RankingPoints = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);
  let [search, setSearch] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState(null);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open, refId]);

  useEffect(() => {
    getData();
    getCategories();
  }, [categoryId]);

  const getCategories = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetRankingCategory"
      );
      const data = [{ id: null, name: "All" }, ...(response?.data ?? [])];

      setCategoryList(data);
    });
  };

  const resetFilters = () => {
    setSearch(null);
    setCategoryId(null);
  };
  debugger;

  const getData = async (
    pageNumber,
    searchTerm = search,
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetRankingPointList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        catId: categoryId,
      },
      "Post"
    );

    if (response?.data) {
      debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          categoryName: item.categoryName ? item.categoryName : "-",
          stagetype:
            Common.Utility.getKeyByValue(
              TournamentMatchStageEnum,
              item.stagetype
            ) ?? "-",
          createdon: item.createdon
            ? Common.Utility.ConvertTime(item.createdon)
            : "-",
          // createdby: item.createdby,
          // isdeleted: item.isdeleted,
        })),
      };

      setData(obj);
    }
  };
  const columns = [
    { title: "Id", type: "text", isVisible: true, key: "id" },
    { title: "Category", type: "text", isVisible: true, key: "categoryName" },
    { title: "Stage Type", type: "text", isVisible: true, key: "stagetype" },
    { title: "Points", type: "text", isVisible: true, key: "points" },
    { title: "createdon", type: "date", isVisible: true, key: "createdon" },
  ];
  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Points?",
      "Delete Points"
    );

    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteRankingPoints?id=${id}`,
        {},
        "Delete"
      );

      Common.SweetAlert.alert(resp.message, "success");

      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => {
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>;
  };

  return (
    <>
      <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
        <AppSearchSelect
          value={categoryId}
          onChange={setCategoryId}
          placeholder={"All"}
          label={"Ranking Category"}
          data={categoryList}
          className={"mb-3 col-span-1"}
        />

        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filter
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Ranking Points"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddRankingPoints
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
          //   searchInputClassName="custom-search-mobile"
          //   search={SearchTypeEnum.Server_Search}
        />
      )}
    </>
  );
};
export default RankingPoints;
